import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Redirect } from 'react-router-dom';
import { onboardingResetPasswordOtpRoute, onboardingBrokerLoginRoute } from 'src/routing/routes';
import { FloatingInput, ShapesDecorativeBorder } from 'src/components';
import ButtonPrimary from '../component/button-primary/button-primary';
import ButtonSecondary from '../component/button-secondary/button-secondary';
import TealiumEvents from 'src/helpers/tealium-events';
import { SelfServiceFormBackground } from '../../self-service-form-background/self-service-form-background';
import { FormContainer } from '../../form-container/form-container';
import toastMessageServiceSingleton from 'src/services/toast-message.service';
import useBrokerLogin from 'src/hooks/useBrokerLogin';
import './first-time-user-broker-id.scss';
import TealiumService from './tealium-first-time-user-broker-id';

export default function FirstTimeUserBrokerId() {
  const [redirectToRoute, setRedirectToRoute] = useState('');
  const { resetPassword } = useBrokerLogin();

  useEffect(() => {
    TealiumService.firstTimeLoginLanding();
  }, []);

  if (!!redirectToRoute) {
    return <Redirect to={redirectToRoute} />;
  }

  return (
    <div className="first-time-user-merchant-id">
      <SelfServiceFormBackground className={'dark-background'}>
        <ShapesDecorativeBorder>
          <Formik initialValues={{ merchantId: '' }} onSubmit={submitResetRequest}>
            {({ isSubmitting, values }) => (
              <FormContainer classname={'container-white'}>
                <Form>
                  <div className="has-text-centered">
                    <h1 className="form-heading heading-four">Setup Your Account</h1>
                    <p className="form-subheading">To start please enter your User ID.</p>
                  </div>
                  <Field
                    name="merchantId"
                    type="text"
                    placeholder="User ID"
                    component={FloatingInput}
                    fieldType="standard"
                    className="id-field"
                    spacing="has-margin-top-5"
                    automationIdPrefix="Reset_Password_Input_MerchantID"
                    subtext="Please note you‘ll recieve an SMS with an OTP pin."
                    autoFocus
                  />

                  <ButtonPrimary
                    type="submit"
                    disabled={isSubmitting || !isFormValid(values)}
                    automationid="Reset_Password_Button_Request_Reset"
                    className="next-button"
                    onClick={() => {
                      TealiumService.firstTimeLoginActions('next');
                    }}
                  >
                    Next
                  </ButtonPrimary>

                  <ButtonSecondary
                    disabled={isSubmitting}
                    automationid="Reset_Password_Button_Back"
                    onClick={() => {
                      TealiumService.firstTimeLoginActions('back');
                      setRedirectToRoute(onboardingBrokerLoginRoute);
                    }}
                    className="back-button"
                  >
                    Back
                  </ButtonSecondary>
                </Form>
              </FormContainer>
            )}
          </Formik>
        </ShapesDecorativeBorder>
      </SelfServiceFormBackground>
    </div>
  );

  function isFormValid(values) {
    return !!values.merchantId;
  }

  async function submitResetRequest(values, helpers) {
    const abortController = new AbortController();
    const { setSubmitting, resetForm } = helpers;

    const { error } = await resetPassword(values.merchantId, abortController, true, false);
    if (!abortController.signal.aborted) {
      setSubmitting(false);

      switch (error) {
        case null:
        case undefined:
          setRedirectToRoute(onboardingResetPasswordOtpRoute);
          break;
        default:
          TealiumEvents.onHandledErrorFormSelfService('Merchant id is invalid');
          toastMessageServiceSingleton.addError(
            'Merchant ID is invalid',
            null,
            '401',
            true,
            null,
            true,
          );
          resetForm();
      }
    }
  }
}
